import { LINKS } from '@/constants/links';
import { Category, SubCategory } from './utils';
import { getAllPrimaryCategories } from './getCategories';

export type NoResults = {
	categories: (Category | SubCategory)[];
	terms: Array<{
		link: string;
		name: string;
	}>;
};

const popularCategoriesIds = {
	cs: [
		537, // Děti a kojenci
		536, // Dům a zahrada
		222, // Elektronika
		166, // Oblečení a doplňky
		988, // Sportovní potřeby
		469, // Zdraví a krása
	],
};

const popularTerms = {
	cs: ['Nike', 'Boty', 'Lego', 'Adidas', 'Hodinky', 'Mikina', 'Kalhoty', 'Tenisky'],
};

function getPopularTerms(): NoResults['terms'] {
	return popularTerms.cs.map((term) => {
		const link = new URL(process.env.NEXT_PUBLIC_BASE_URL + LINKS().gcssHomepageSearch);
		link.searchParams.set('search', term);

		return {
			link: link.toString(),
			name: term,
		};
	});
}

async function getPopularCategories(): Promise<NoResults['categories']> {
	const allPrimaryCategories = await getAllPrimaryCategories();

	return allPrimaryCategories.filter((category) => popularCategoriesIds.cs.includes(category.id));
}

export async function getNoResultsData(): Promise<NoResults> {
	return {
		categories: await getPopularCategories(),
		terms: getPopularTerms(),
	};
}
